module.exports = __webpack_public_path__ + "634dd2188e8044b35517f64ea5367448.svg";